@if (!isReadOnly) {
  <div>
    <div class="form-group">
      @if (title) {
        <label class="text-gray-dark">{{ title | translate }}</label>
      }
      @if (tooltip) {
        <i-feather class="text-info ml-2" name="info" [ngbTooltip]="tooltip | translate"></i-feather>
      }
      <div class="input-group">
        @for (choice of choices; track choice; let choiceIndex = $index) {
          <div class="mb-3 custom-control custom-radio" [ngClass]="columnSpanClass" [attr.data-index]="choiceIndex">
            <input
              [disabled]="disabled || choice.disabled"
              type="radio"
              class="custom-control-input"
              [id]="choiceComponentIdentifier + '_' + choice.key"
              [name]="choiceComponentIdentifier"
              (change)="onChoiceChange(choice)"
              (focusout)="isValid()"
              [checked]="!choice.disabled && (value === choice.key || defaultValue === choice.key)"
            />
            <label class="custom-control-label" [for]="choiceComponentIdentifier + '_' + choice.key">
              @if (choice && choice.display) {
                <span innerHtml="{{ choice.display | translate }}"></span>
              }
              @if (choice.choiceTooltip) {
                <i-feather class="ml-2" name="info" [ngbTooltip]="choice.choiceTooltip | translate"></i-feather>
              }
              @if (choice && choice.recommendedLabel) {
                <span innerHtml="{{ choice.recommendedLabel | translate }}" class="custom-recommended-label"></span>
              }
            </label>
          </div>
        }
      </div>
      @if (validationErrors && validationErrors.length > 0) {
        <div class="invalid-field">
          @for (error of validationErrors; track error) {
            <span> {{ error | translate }} <br /> </span>
          }
        </div>
      }
    </div>
  </div>
}

@if (isReadOnly) {
  <div>
    <div class="form-group read-only">
      @if (!hideReadOnlyLabel) {
        <label class="text-gray-dark">{{ title! | translate }}</label>
      }
      <div class="input-group">
        @if (valueTemplate) {
          <span>{{ valueTemplate | translate }}</span>
        }
        @if (!valueTemplate) {
          <div class="input-group">-</div>
        }
      </div>
    </div>
  </div>
}
